import React from 'react'
import { withTranslation } from 'react-i18next'

function OtpResult(props) {
    const {t}=props; 
  return (
    <>
        {props.status ?
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{color: "#000 !important"}}>Success</h2>
                                    <p>Please click proceed to access your Mobile door key</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-check"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            <button onClick={props.proceedNext} class="button w-100">Proceed</button>
                        </div>
                    </div>
                </div>
            </section>
            :
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{color: "#000 !important"}}>Verification failed</h2>
                                    <p> {t("door_key_auth.resend_otp_subheading")}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-times"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            <button class="button w-45 primary margin-right-1" onClick={props.resendOTP}>Yes</button>
                            <button class="button w-45" onClick={props.cancel}>No</button>
                        </div>
                    </div>
                </div>
            </section>        
        }
    </>
  )
}

export default (withTranslation("translations")(OtpResult))